import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import './Menu.scss';

const InstallMenu = (props, context) => {
  const projectsState = useSelector((state) => state.leaksList.projectsList);
  const selectedProjectId = useSelector((state) => state.leaksList.selectedProject);
  const selectedProjectIndex = projectsState.projectIndexMap[selectedProjectId];
  const projectItem = projectsState.items[selectedProjectIndex];

  const { addNewInstallItem, onChange, installContext } = props;

  return (
    <div className="manage-menu">
      { (installContext == 'SOPs' || installContext == 'Interferences' || installContext == 'PressureSensors') &&
        <button
          className="btn-success create-item"
          onClick={() => {
            addNewInstallItem(installContext);
          }}
        >
          <i title={context.t('add')} />
        </button>
      }

      {/* SOP's button */}
      <button
        className="btn-menu SOPs"
        onClick={() => {
          onChange('SOPs');
        }
        }
      >
        <i title={context.t('sops')} />
      </button>

      {/* Sensors button */}
      <button
        className="btn-menu Sensors"
        onClick={() => {
          onChange('Sensors');
        }
        }
      >
        <i title={context.t('sensors')} />
      </button>

      {/* Pressure Sensors button - only show when is_pressure_new is true */}
      {projectItem?.is_pressure_new &&
        <button
          className="btn-menu PrsSensors"
          onClick={() => {
            onChange('PressureSensors');
          }}
        >
          <i title={context.t('pressure_sensors')} />
        </button>
      }

      {/* Interference button */}
      <button
        className="btn-menu interference"
        onClick={() => {
          onChange('Interferences');
        }}>
          <i title={context.t("interferences")} />
        </button>
    </div>
  );
}

InstallMenu.contextTypes = {
  t: PropTypes.func.isRequired
};

export default InstallMenu;
